import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import router from "app/router";

import ErrorBoundary from "components/error/ErrorBoundary";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <RouterProvider router={router} />
  </ErrorBoundary>
);
